import { GRAPHQL_URL, BASE_URL } from '@lib/constants';
import AuthenticationService from '@lib/auth/AuthenticationService';

const logUserIn =
	({ email, password, awaitProspectus = false }) =>
	async (dispatch) => {
		dispatch({
			type: 'USER_LOGGED_IN',
			payload: false,
			authStatus: 'pending',
		});

		const response = await fetch(GRAPHQL_URL, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({
				query: `
                mutation LoginUser {
                    login(input: {clientMutationId: "login", username: "${email}", password: "${password}"}) {
                        user {
                            id
                            jwtAuthToken
                            jwtRefreshToken
                            name
                            capabilities
                        }
                    }
                }`,
			}),
		});

		const data = await response.json();

		// Failure
		if (data.errors) {
			dispatch({
				type: 'FAILED_USER_LOG_IN',
				payload: ['The provided code is invalid please check your email'],
			});

			return false;
		}

		// Success
		if (data.data && data.data.login && data.data.login.user.jwtAuthToken) {
			const user = data.data.login.user;

			const auth = new AuthenticationService();
			auth.setTokenInStorage(user.jwtAuthToken);
			auth.setJwtRefreshToken(user.jwtRefreshToken);

			// 👉 Mark as authenticated ASAP
			dispatch({
				type: 'USER_LOGGED_IN',
				payload: true,
				authStatus: 'finished',
			});

			dispatch({
				type: 'SET_USER',
				payload: {
					name: user.name,
					email: email,
				},
			});

			dispatch({
				type: 'SET_JUST_LOGGED_IN',
				payload: true,
				authStatus: 'finished',
			});

			// 👉 Load prospectus in the background - don't block login
			const prospectusRequest = (async () => {
				try {
					const loadProspectus = await fetch(`${BASE_URL}/wp-json/edu_api/get/prospectus`, {
						method: 'POST',
						headers: {
							Authorization: `Bearer ${user.jwtAuthToken}`,
							'Content-Type': 'application/json',
						},
					});

					const prospectusData = await loadProspectus.json();

					if (prospectusData) {
						dispatch({
							type: 'FOUND_PROSPECTUS',
							payload: {
								data: prospectusData.data,
								prospectusId: prospectusData.id,
								selectedWayfinderAnswers: prospectusData.selectedTerms || {},
							},
						});
					}
				} catch (e) {
					console.error('Failed to load prospectus', e);
				}
			})();

			if (awaitProspectus) {
				await prospectusRequest;
			}

			return true;
		}

		return false;
	};

export default logUserIn;
